
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.274","height":"32.946"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 1"}},[_c('g',{attrs:{"data-name":"Gruppe 171","transform":"translate(1 1)","fill":"none","stroke":"#fff","stroke-width":"2"}},[_c('rect',{attrs:{"data-name":"Rechteck 78","width":"23.274","height":"27.929","rx":"2","transform":"translate(0 3.016)","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Pfad 122","d":"M16.513 2.61v1.957a1.957 1.957 0 01-1.957 1.957H8.031a1.957 1.957 0 01-1.957-1.957V2.61","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Pfad 123","d":"M8.684 2.61a2.61 2.61 0 015.22 0","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Linie 17","stroke-miterlimit":"10","d":"M2.327 11.162h10.474"}}),_c('path',{attrs:{"data-name":"Pfad 124","d":"M15.208 11.739l1.3 1.3 2.61-2.61","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Linie 18","stroke-miterlimit":"10","d":"M2.327 18.145h10.474"}}),_c('path',{attrs:{"data-name":"Pfad 125","d":"M15.208 18.264l1.3 1.3 2.61-2.61","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Linie 19","stroke-miterlimit":"10","d":"M2.327 25.127h10.474"}}),_c('path',{attrs:{"data-name":"Pfad 126","d":"M15.208 24.788l1.3 1.3 2.61-2.61","stroke-linecap":"round","stroke-linejoin":"round"}})])])])
          )
        }
      }
    